// extracted by mini-css-extract-plugin
module.exports = {"sliderTicks":"_3nxJf"};